import {ProductAttributesField, ProductField} from '@treez/commons/sharedTypings/product';

export const useUiWrapperProductFields = () => {
    const {EFFECT, FLAVOR, GENERAL, INGREDIENT, INTERNAL} = ProductAttributesField;
    const {BRAND_NAME} = ProductField;
    return [FLAVOR, EFFECT, GENERAL, INGREDIENT, INTERNAL, BRAND_NAME];
};
